import FacebookIcon from "../../assets/svg/facebook.svg";
import TwitterIcon from "../../assets/svg/twitter.svg";
import InstagramIcon from "../../assets/svg/instagram.svg";
import YoutubeIcon from "../../assets/svg/youtube.svg";
import { NavLink, useLocation } from "react-router-dom";
const Footer = () => {
  const year = new Date().getFullYear();
  const location = useLocation();
  const isComingSoonPage = ["/coming-soon"].includes(location.pathname);

  if (isComingSoonPage) return null;

  return (
    <div className={'footer'}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className={'d-flex align-items-lg-center justify-content-between gap-3 top-footer'}>
              <ul>
                <li>
                  <NavLink to="/" className="nav-link">
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/shop" className="nav-link">
                    Shop
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/customize-wheat" className="nav-link">
                    Customise Wheat
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/about-us" className="nav-link">
                    About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/contact-us" className="nav-link">
                    Contact Us
                  </NavLink>
                </li>
              </ul>
              <div className="social-link">
                <ul>
                  <li>
                    <a href="https://www.facebook.com/share/1E3coVJPzh/?mibextid=wwXIfr">
                      <img className={'img-fluid'} src={FacebookIcon} alt="" />
                    </a>
                  </li>
                  {/* <li>
                    <a href="#">
                      <img className={'img-fluid'} src={TwitterIcon} alt="" />
                    </a>
                  </li> */}
                  <li>
                    <a href="https://www.instagram.com/moolchandjifoods?igsh=MWlzMDc4enFidXhjNQ%3D%3D&utm_source=qr">
                      <img className={'img-fluid'} src={InstagramIcon} alt="" />
                    </a>
                  </li>
                  <li>
                    <a href="https://youtube.com/@moolchandjifoodss?si=vN0u_HjTISsNaitj">
                      <img className={'img-fluid'} src={YoutubeIcon} alt="" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-footer">
        <div className="container">
          <div className="row">
            <div className="d-flex align-items-center justify-content-between gap-2">
              <p>© Moolchandji Foods {year}</p>
              <ul className={'d-flex align-items-center p-0 m-0'}>
                <li>
                  <NavLink to="/refund-policy">Refund policy</NavLink>
                </li>
                <li>
                  <NavLink to="/privacy-policy">Privacy policy</NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Footer